(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("babylonjs"));
	else if(typeof define === 'function' && define.amd)
		define("babylonjs-node-editor", ["babylonjs"], factory);
	else if(typeof exports === 'object')
		exports["babylonjs-node-editor"] = factory(require("babylonjs"));
	else
		root["NODEEDITOR"] = factory(root["BABYLON"]);
})((typeof self !== "undefined" ? self : typeof global !== "undefined" ? global : this), (__WEBPACK_EXTERNAL_MODULE__5597__) => {
return 